export default "__VITE_ASSET__TMKMCaH___"